import _asyncToGenerator from "/home/runner/work/hakka.finance/hakka.finance/node_modules/@babel/runtime/helpers/esm/asyncToGenerator";
import _classCallCheck from "/home/runner/work/hakka.finance/hakka.finance/node_modules/@babel/runtime/helpers/esm/classCallCheck";
import _createClass from "/home/runner/work/hakka.finance/hakka.finance/node_modules/@babel/runtime/helpers/esm/createClass";
import _inherits from "/home/runner/work/hakka.finance/hakka.finance/node_modules/@babel/runtime/helpers/esm/inherits";
import _possibleConstructorReturn from "/home/runner/work/hakka.finance/hakka.finance/node_modules/@babel/runtime/helpers/esm/possibleConstructorReturn";
import _getPrototypeOf from "/home/runner/work/hakka.finance/hakka.finance/node_modules/@babel/runtime/helpers/esm/getPrototypeOf";
import _regeneratorRuntime from "/home/runner/work/hakka.finance/hakka.finance/node_modules/@babel/runtime/regenerator";

function _createSuper(Derived) { var hasNativeReflectConstruct = _isNativeReflectConstruct(); return function _createSuperInternal() { var Super = _getPrototypeOf(Derived), result; if (hasNativeReflectConstruct) { var NewTarget = _getPrototypeOf(this).constructor; result = Reflect.construct(Super, arguments, NewTarget); } else { result = Super.apply(this, arguments); } return _possibleConstructorReturn(this, result); }; }

function _isNativeReflectConstruct() { if (typeof Reflect === "undefined" || !Reflect.construct) return false; if (Reflect.construct.sham) return false; if (typeof Proxy === "function") return true; try { Boolean.prototype.valueOf.call(Reflect.construct(Boolean, [], function () {})); return true; } catch (e) { return false; } }

import { EventEmitter } from "events";
import { IJsonRpcProvider, isJsonRpcResponse, formatJsonRpcRequest, isJsonRpcError, getBigIntRpcId } from "@walletconnect/jsonrpc-utils";
export var JsonRpcProvider = /*#__PURE__*/function (_IJsonRpcProvider) {
  _inherits(JsonRpcProvider, _IJsonRpcProvider);

  var _super = _createSuper(JsonRpcProvider);

  function JsonRpcProvider(connection) {
    var _this;

    _classCallCheck(this, JsonRpcProvider);

    _this = _super.call(this, connection);
    _this.events = new EventEmitter();
    _this.hasRegisteredEventListeners = false;
    _this.connection = _this.setConnection(connection);

    if (_this.connection.connected) {
      _this.registerEventListeners();
    }

    return _this;
  }

  _createClass(JsonRpcProvider, [{
    key: "connect",
    value: function () {
      var _connect = _asyncToGenerator( /*#__PURE__*/_regeneratorRuntime.mark(function _callee() {
        var connection,
            _args = arguments;
        return _regeneratorRuntime.wrap(function _callee$(_context) {
          while (1) {
            switch (_context.prev = _context.next) {
              case 0:
                connection = _args.length > 0 && _args[0] !== undefined ? _args[0] : this.connection;
                _context.next = 3;
                return this.open(connection);

              case 3:
              case "end":
                return _context.stop();
            }
          }
        }, _callee, this);
      }));

      function connect() {
        return _connect.apply(this, arguments);
      }

      return connect;
    }()
  }, {
    key: "disconnect",
    value: function () {
      var _disconnect = _asyncToGenerator( /*#__PURE__*/_regeneratorRuntime.mark(function _callee2() {
        return _regeneratorRuntime.wrap(function _callee2$(_context2) {
          while (1) {
            switch (_context2.prev = _context2.next) {
              case 0:
                _context2.next = 2;
                return this.close();

              case 2:
              case "end":
                return _context2.stop();
            }
          }
        }, _callee2, this);
      }));

      function disconnect() {
        return _disconnect.apply(this, arguments);
      }

      return disconnect;
    }()
  }, {
    key: "on",
    value: function on(event, listener) {
      this.events.on(event, listener);
    }
  }, {
    key: "once",
    value: function once(event, listener) {
      this.events.once(event, listener);
    }
  }, {
    key: "off",
    value: function off(event, listener) {
      this.events.off(event, listener);
    }
  }, {
    key: "removeListener",
    value: function removeListener(event, listener) {
      this.events.removeListener(event, listener);
    }
  }, {
    key: "request",
    value: function () {
      var _request2 = _asyncToGenerator( /*#__PURE__*/_regeneratorRuntime.mark(function _callee3(_request, context) {
        return _regeneratorRuntime.wrap(function _callee3$(_context3) {
          while (1) {
            switch (_context3.prev = _context3.next) {
              case 0:
                return _context3.abrupt("return", this.requestStrict(formatJsonRpcRequest(_request.method, _request.params || [], _request.id || getBigIntRpcId().toString()), context));

              case 1:
              case "end":
                return _context3.stop();
            }
          }
        }, _callee3, this);
      }));

      function request(_x, _x2) {
        return _request2.apply(this, arguments);
      }

      return request;
    }()
  }, {
    key: "requestStrict",
    value: function () {
      var _requestStrict = _asyncToGenerator( /*#__PURE__*/_regeneratorRuntime.mark(function _callee5(request, context) {
        var _this2 = this;

        return _regeneratorRuntime.wrap(function _callee5$(_context5) {
          while (1) {
            switch (_context5.prev = _context5.next) {
              case 0:
                return _context5.abrupt("return", new Promise( /*#__PURE__*/function () {
                  var _ref = _asyncToGenerator( /*#__PURE__*/_regeneratorRuntime.mark(function _callee4(resolve, reject) {
                    return _regeneratorRuntime.wrap(function _callee4$(_context4) {
                      while (1) {
                        switch (_context4.prev = _context4.next) {
                          case 0:
                            if (_this2.connection.connected) {
                              _context4.next = 9;
                              break;
                            }

                            _context4.prev = 1;
                            _context4.next = 4;
                            return _this2.open();

                          case 4:
                            _context4.next = 9;
                            break;

                          case 6:
                            _context4.prev = 6;
                            _context4.t0 = _context4["catch"](1);
                            reject(_context4.t0);

                          case 9:
                            _this2.events.on("".concat(request.id), function (response) {
                              if (isJsonRpcError(response)) {
                                reject(response.error);
                              } else {
                                resolve(response.result);
                              }
                            });

                            _context4.prev = 10;
                            _context4.next = 13;
                            return _this2.connection.send(request, context);

                          case 13:
                            _context4.next = 18;
                            break;

                          case 15:
                            _context4.prev = 15;
                            _context4.t1 = _context4["catch"](10);
                            reject(_context4.t1);

                          case 18:
                          case "end":
                            return _context4.stop();
                        }
                      }
                    }, _callee4, null, [[1, 6], [10, 15]]);
                  }));

                  return function (_x5, _x6) {
                    return _ref.apply(this, arguments);
                  };
                }()));

              case 1:
              case "end":
                return _context5.stop();
            }
          }
        }, _callee5);
      }));

      function requestStrict(_x3, _x4) {
        return _requestStrict.apply(this, arguments);
      }

      return requestStrict;
    }()
  }, {
    key: "setConnection",
    value: function setConnection() {
      var connection = arguments.length > 0 && arguments[0] !== undefined ? arguments[0] : this.connection;
      return connection;
    }
  }, {
    key: "onPayload",
    value: function onPayload(payload) {
      this.events.emit("payload", payload);

      if (isJsonRpcResponse(payload)) {
        this.events.emit("".concat(payload.id), payload);
      } else {
        this.events.emit("message", {
          type: payload.method,
          data: payload.params
        });
      }
    }
  }, {
    key: "onClose",
    value: function onClose(event) {
      if (event && event.code === 3000) {
        this.events.emit("error", new Error("WebSocket connection closed abnormally with code: ".concat(event.code, " ").concat(event.reason ? "(".concat(event.reason, ")") : "")));
      }

      this.events.emit("disconnect");
    }
  }, {
    key: "open",
    value: function () {
      var _open = _asyncToGenerator( /*#__PURE__*/_regeneratorRuntime.mark(function _callee6() {
        var connection,
            _args6 = arguments;
        return _regeneratorRuntime.wrap(function _callee6$(_context6) {
          while (1) {
            switch (_context6.prev = _context6.next) {
              case 0:
                connection = _args6.length > 0 && _args6[0] !== undefined ? _args6[0] : this.connection;

                if (!(this.connection === connection && this.connection.connected)) {
                  _context6.next = 3;
                  break;
                }

                return _context6.abrupt("return");

              case 3:
                if (this.connection.connected) this.close();

                if (!(typeof connection === "string")) {
                  _context6.next = 8;
                  break;
                }

                _context6.next = 7;
                return this.connection.open(connection);

              case 7:
                connection = this.connection;

              case 8:
                this.connection = this.setConnection(connection);
                _context6.next = 11;
                return this.connection.open();

              case 11:
                this.registerEventListeners();
                this.events.emit("connect");

              case 13:
              case "end":
                return _context6.stop();
            }
          }
        }, _callee6, this);
      }));

      function open() {
        return _open.apply(this, arguments);
      }

      return open;
    }()
  }, {
    key: "close",
    value: function () {
      var _close = _asyncToGenerator( /*#__PURE__*/_regeneratorRuntime.mark(function _callee7() {
        return _regeneratorRuntime.wrap(function _callee7$(_context7) {
          while (1) {
            switch (_context7.prev = _context7.next) {
              case 0:
                _context7.next = 2;
                return this.connection.close();

              case 2:
              case "end":
                return _context7.stop();
            }
          }
        }, _callee7, this);
      }));

      function close() {
        return _close.apply(this, arguments);
      }

      return close;
    }()
  }, {
    key: "registerEventListeners",
    value: function registerEventListeners() {
      var _this3 = this;

      if (this.hasRegisteredEventListeners) return;
      this.connection.on("payload", function (payload) {
        return _this3.onPayload(payload);
      });
      this.connection.on("close", function (event) {
        return _this3.onClose(event);
      });
      this.connection.on("error", function (error) {
        return _this3.events.emit("error", error);
      });
      this.connection.on("register_error", function (error) {
        return _this3.onClose();
      });
      this.hasRegisteredEventListeners = true;
    }
  }]);

  return JsonRpcProvider;
}(IJsonRpcProvider);
export default JsonRpcProvider;